var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCaretLeft = function SvgIconCaretLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343330",
    d: "m7.332 12.424 7.5 7.5a1.127 1.127 0 1 0 1.594-1.594l-6.704-6.702 6.702-6.704a1.126 1.126 0 0 0-1.228-1.838c-.137.056-.261.14-.366.244l-7.5 7.5a1.124 1.124 0 0 0 .002 1.594"
  })));
};
export default SvgIconCaretLeft;